import React from "react";
import ContactOneForm from "./ContactOneForm";
import ContactOneInfoItem from "./ContactOneInfoItem";

const ContactOne = () => {
  const info_items = [
    // {
    //   icon: "fa-envelope",
    //   content: (
    //     <>
    //       <a
    //         href="https://mail.google.com/mail/?view=cm&fs=1&to=info@diagnostica.app"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //       >
    //         {" "}
    //         info@diagnostica.app
    //       </a>
    //     </>
    //   ),
    // },
   
    // {
    //   icon: "fa-telegram",
    //   content: (
    //     <>
    //       <a
    //         href="https://t.me/diagtoken"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //       >
    //         {" "}
    //         Official Telegram Channel
    //       </a>
    //     </>
    //   ),
    // },
  ];

  return (
    <section id="contact" className="contact-area pt-70 pb-110">
      <div className="container">
        {/* section title */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-70">
              <h2 className="title">
                <span>Contact</span> Us
              </h2>
            </div>
          </div>
        </div>

        {/* secction info */}
        <div className="contact-info-wrap mb-0">
          <div className="row justify-content-center">
            {info_items.map((x, index) => (
              <div key={index} className="col-lg-4 col-sm-6">
                <ContactOneInfoItem item={x} />
              </div>
            ))}
          </div>
        </div>

        {/* section form */}
        <ContactOneForm />
      </div>
    </section>
  );
};

export default ContactOne;
